export default __webpack_public_path__ + "img/bg-9de0da6b.png";